export const MOBILE_BALANCE_MODAL_MAX_HEIGHT = 'min(90vh, 620px)'
